export default __webpack_public_path__ + "fonts/banner_video.d5ada6f126e504c3f4806926e7cc9182.mp4";